import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Smartphone, Send, QrCode } from 'lucide-react';
import PhoneFrame from '../phone-frame/PhoneFrame';
import { landingPageApi } from '../../api/landing-page-api';

const DEFAULT_APP_STORE = '#';
const DEFAULT_PLAY_STORE = '#';

function Download01() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [sent, setSent] = useState(false);
  const [appStoreUrl, setAppStoreUrl] = useState(DEFAULT_APP_STORE);
  const [playStoreUrl, setPlayStoreUrl] = useState(DEFAULT_PLAY_STORE);

  useEffect(() => {
    landingPageApi.getMobileApps().then(data => {
      if (data) {
        if (data.app_store?.url) setAppStoreUrl(data.app_store.url);
        if (data.play_store?.url) setPlayStoreUrl(data.play_store.url);
      }
    });
  }, []);

  const handleSendLink = (e) => {
    e.preventDefault();
    if (phoneNumber) {
      setSent(true);
      setPhoneNumber('');
    }
  };

  return (
    <section id="download" className="download" style={{
      padding: '100px 0', position: 'relative', overflow: 'hidden',
      background: 'linear-gradient(135deg, #0b1120 0%, #0f1a3a 50%, #1a0f2e 100%)',
    }}>
      {/* Background decorative elements */}
      <div style={{
        position: 'absolute', bottom: '-15%', right: '-8%', width: 600, height: 600,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(12,143,134,0.08) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', top: '-10%', left: '-5%', width: 400, height: 400,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(139,92,246,0.05) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: `radial-gradient(rgba(12,143,134,0.03) 1px, transparent 1px)`,
        backgroundSize: '60px 60px',
        pointerEvents: 'none', opacity: 0.5,
      }} />

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="row align-items-center">
          <div className="col-xl-6 col-md-12">
            <div data-aos="fade-up" data-aos-duration="1000">
              <h3 className="heading" style={{ color: '#fff', marginBottom: 14, fontSize: 'clamp(32px, 4vw, 44px)' }}>
                Siap Mulai Perjalanan Trading Anda?
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.55)', maxWidth: 480, fontSize: 'clamp(15px, 1.5vw, 17px)', marginBottom: 36, lineHeight: 1.7 }}>
                Download aplikasi Tradiora sekarang atau mulai sesi mentoring dengan para ahli kami.
              </p>

              {/* Store buttons */}
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 40 }}>
                <a
                  href={appStoreUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 10,
                    background: '#fff', borderRadius: 14, padding: '12px 26px',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                  }}
                  className="download-badge"
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 1.58-.6 3.2-2.12 4.08-.83.47-1.55.6-1.62.17z" fill="black"/>
                  </svg>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: 9, color: '#666', lineHeight: 1, letterSpacing: '0.3px' }}>Download di</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: '#000', lineHeight: 1.2 }}>App Store</div>
                  </div>
                </a>

                <a
                  href={playStoreUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 10,
                    background: '#fff', borderRadius: 14, padding: '12px 26px',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                  }}
                  className="download-badge"
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M4.56 2.5L14.8 12.5L4.56 22.5C4.22 22.5 3.89 22.37 3.63 22.11C3.37 21.85 3.24 21.52 3.24 21.18V3.82C3.24 3.48 3.37 3.15 3.63 2.89C3.89 2.63 4.22 2.5 4.56 2.5Z" fill="#34A853"/>
                    <path d="M17.68 9.59L14.8 12.5L20.26 17.96L22.56 16.59C23.04 16.29 23.28 15.81 23.28 15.33V9.67C23.28 9.19 23.04 8.71 22.56 8.41L20.26 7.04L17.68 9.59Z" fill="#FBBC04"/>
                    <path d="M14.8 12.5L3.63 2.89C3.37 3.15 3.24 3.48 3.24 3.82V12.5V21.18C3.24 21.52 3.37 21.85 3.63 22.11L14.8 12.5Z" fill="#4285F4"/>
                    <path d="M14.8 12.5L20.26 7.04L17.68 9.59L14.8 12.5ZM22.56 8.41L14.8 12.5L20.26 17.96L22.56 16.59C23.04 16.29 23.28 15.81 23.28 15.33V9.67C23.28 9.19 23.04 8.71 22.56 8.41Z" fill="#EA4335"/>
                  </svg>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: 9, color: '#666', lineHeight: 1, letterSpacing: '0.3px' }}>Dapatkan di</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: '#000', lineHeight: 1.2 }}>Google Play</div>
                  </div>
                </a>

                <Link
                  to="/mentor"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 8,
                    background: 'linear-gradient(135deg, #0C8F86, #8b5cf6)',
                    color: '#fff', fontWeight: 600, fontSize: 14,
                    borderRadius: 14, padding: '14px 26px', textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 6px 20px rgba(12,143,134,0.3)',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 30px rgba(12,143,134,0.4)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(12,143,134,0.3)';
                  }}
                >
                  <GraduationCap size={18} />
                  Cari Mentor
                </Link>
              </div>

              {/* Phone input */}
              <div style={{ marginBottom: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 14 }}>
                  <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.08)' }} />
                  <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: 13, fontWeight: 500 }}>atau</span>
                  <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.08)' }} />
                </div>

                <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 14, marginBottom: 14 }}>
                  Kirim link download langsung ke WhatsApp Anda:
                </p>
                {sent ? (
                  <div style={{
                    background: 'rgba(88,189,125,0.12)', borderRadius: 12,
                    padding: '16px 20px', color: '#58bd7d', fontWeight: 600, fontSize: 14,
                    border: '1px solid rgba(88,189,125,0.2)',
                    display: 'flex', alignItems: 'center', gap: 8,
                  }}>
                    <Send size={16} />
                    Link download telah dikirim ke nomor WhatsApp Anda!
                  </div>
                ) : (
                  <form onSubmit={handleSendLink} style={{ display: 'flex', gap: 8, maxWidth: 420 }}>
                    <input
                      type="tel"
                      placeholder="Contoh: 08123456789"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      required
                      style={{
                        flex: 1,
                        padding: '14px 18px',
                        borderRadius: 12,
                        border: '1px solid rgba(255,255,255,0.12)',
                        background: 'rgba(255,255,255,0.05)',
                        color: '#fff',
                        fontSize: 14,
                        outline: 'none',
                      }}
                    />
                    <button
                      type="submit"
                      style={{
                        padding: '14px 24px',
                        borderRadius: 12,
                        border: 'none',
                        background: '#58bd7d',
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: 14,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        display: 'flex', alignItems: 'center', gap: 6,
                        boxShadow: '0 6px 20px rgba(88,189,125,0.3)',
                      }}
                      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; }}
                      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
                    >
                      <Send size={16} />
                      Kirim Link
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>

          {/* Right - Phone mockup + QR */}
          <div className="col-xl-6 col-md-12">
            <div style={{
              display: 'flex', justifyContent: 'center', gap: 30, alignItems: 'center',
              paddingTop: 40,
            }} data-aos="fade-left" data-aos-duration="1000">
              {/* Phone frame with dashboard preview */}
              <PhoneFrame style={{ width: 230, height: 460, maxWidth: '60vw' }}>
                <div style={{
                  height: '100%',
                  background: 'linear-gradient(180deg, #0a1628, #0d1f3c)',
                  borderRadius: '0 0 28px 28px',
                  padding: '16px 14px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 14,
                }}>
                  <div style={{
                    width: 48, height: 48, borderRadius: 14,
                    background: 'linear-gradient(135deg, #0C8F86, #087a72)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 8px 30px rgba(12,143,134,0.35)',
                  }}>
                    <Smartphone size={24} color="#fff" />
                  </div>
                  <div style={{ color: '#fff', fontSize: 13, fontWeight: 700, textAlign: 'center' }}>
                    Tradiora
                  </div>
                  <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 10, textAlign: 'center' }}>
                    AI-Powered Trading Platform
                  </div>
                  <div style={{
                    width: '80%', height: 2,
                    background: 'linear-gradient(90deg, transparent, rgba(12,143,134,0.3), transparent)',
                  }} />
                  <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 9, textAlign: 'center', lineHeight: 1.5 }}>
                    Scan QR code untuk download
                  </div>
                </div>
              </PhoneFrame>

              {/* QR Code device */}
              <div style={{
                width: 130, height: 130,
                background: '#fff',
                borderRadius: 18,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 10px 35px rgba(0,0,0,0.35)',
                padding: 12,
              }}>
                <div style={{
                  width: '100%', height: '100%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexDirection: 'column', gap: 4,
                }}>
                  <QrCode size={60} color="#0C8F86" />
                  <span style={{ color: '#0C8F86', fontSize: 9, fontWeight: 700 }}>SCAN QR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Download01;
